import React, { useState } from 'react';

// Added onSuccess to the props
const PdfUploader = ({ isOpen, onClose, onSuccess }) => {
    const [file, setFile] = useState(null);
    const [isConverting, setIsConverting] = useState(false);
    const [error, setError] = useState(null);

    if (!isOpen) return null;

    const handleClose = () => {
        setFile(null);
        setError(null);
        setIsConverting(false);
        onClose();
    };

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];

        if (selectedFile && selectedFile.type !== 'application/pdf') {
            setError('Please select a valid PDF file.');
            setFile(null);
            return;
        }

        setError(null);
        setFile(selectedFile);
    };

    const handleUpload = async (event) => {
        event.preventDefault();
        if (!file) return;

        setIsConverting(true);
        setError(null);

        const formData = new FormData();
        formData.append('file', file);

        try {
            const response = await fetch('/api/conversion/pdf-to-svg', {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) {
                const errorText = await response.text();
                throw new Error(errorText || 'Conversion failed.');
            }

            // 1. Read the response as raw text (the SVG string) instead of a Blob
            const svgText = await response.text();

            // 2. Pass the raw string back to the parent component
            if (onSuccess) {
                onSuccess(svgText);
            }

            // Reset local state
            setFile(null);
            setIsConverting(false);

        } catch (err) {
            setError(err.message);
            setIsConverting(false);
        }
    };

    return (
        <div style={overlayStyle}>
            <div style={modalStyle}>
                <button onClick={handleClose} style={closeButtonStyle}>&times;</button>

                <h2 style={{ marginTop: 0 }}>Convert PDF to SVG</h2>

                <form onSubmit={handleUpload} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                    <input
                        type="file"
                        accept="application/pdf"
                        onChange={handleFileChange}
                        disabled={isConverting}
                    />

                    {error && <div style={{ color: 'red', fontSize: '14px' }}>{error}</div>}

                    <button
                        type="submit"
                        disabled={!file || isConverting}
                        style={{
                            padding: '10px',
                            cursor: (!file || isConverting) ? 'not-allowed' : 'pointer',
                            backgroundColor: (!file || isConverting) ? '#ccc' : '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px'
                        }}
                    >
                        {isConverting ? 'Converting...' : 'Upload and Convert'}
                    </button>
                </form>
            </div>
        </div>
    );
};

// Inline Styles for the Modal
const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
};

const modalStyle = {
    backgroundColor: 'white',
    padding: '30px',
    borderRadius: '8px',
    minWidth: '320px',
    position: 'relative',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)'
};

const closeButtonStyle = {
    position: 'absolute',
    top: '10px',
    right: '15px',
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    color: '#555'
};

export default PdfUploader;